/**
 * @file: 逻辑移动
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import NextTick from '../../utils/nextTick';
import { StageEvent } from '../../message/index';
import { del } from '../../interaction/remove/delete';
import { runForceUpdate } from '../../update/runForceUpdate';
import { tips } from '../../UIToolkit/popover/index';

function logic(moveTaskQueue: Array<LogicMoveTask>): void {
    let forceUpdateList: Array<CubeId> = [];

    if (!moveTaskQueue.length) {
        return;
    }

    moveTaskQueue.forEach((moveTask: LogicMoveTask): void => {
        normalMove(moveTask);
    });
}

function normalMove(moveTask: LogicMoveTask): void {
    let moveCube: CubeNode = CubeTree.findByCubeId(moveTask.from.moveTarget);
    let newParent: CubeNode = CubeTree.findByCubeId(moveTask.to.parent);
    let $newParentSlot: JQuery<HTMLElement> = newParent.jView.find(`.${newParent.dslot}`);
    let targetCube: CubeNode|null = CubeTree.findByCubeId(moveTask.to.insertBefore);

    // 先移动dom
    moveDom(targetCube, $newParentSlot, moveCube);

    // 再更新cube树
    updateCubeTree(moveTask);
}

function moveDom(targetCube: CubeNode|null, $slot: JQuery<HTMLElement>, moveCube: CubeNode): void {
    if (targetCube) {
        targetCube.jView.before(moveCube.jView);
    }
    else {
        $slot.append(moveCube.jView);
    }
}

function updateCubeTree(moveTask: LogicMoveTask): void {
    CubeTree.moveCube([
        {
            from: {
                parent: moveTask.from.parent,
                moveTarget: moveTask.from.moveTarget
            },
            to: {
                parent: moveTask.to.parent,
                insertBefore: moveTask.to.insertBefore
            }
        }
    ]);
}

function isAddSubGoods(target: CubeId, to: CubeId): boolean {
    return CubeTree.isGoods(target) && CubeTree.isGoods(to);
}

export {
    logic
}
